module.exports = __webpack_public_path__ + "components/flag/static/square/lb-9f96a27e1c6393be7775e503b41222fb.svg";